import { useRouteMatch } from 'react-router-dom';
import { flatMap } from 'lodash-es';

import { tools } from '../tools-list/constants';

/**
 * Uses the current frontend route to find the tool description in the tools-list/constants file.
 *
 * @returns {string} - The description of the tool in the tools-list/constants file
 */
export const useToolDescription = () => {
  const { path } = useRouteMatch();
  const toolsList = flatMap(tools.map((tool) => tool.items));
  const toolDesc = toolsList.find((tool) => tool.path === path)?.description;
  return toolDesc;
};
